'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactResponsiveDropdown = require('react-responsive-dropdown');

var _reactResponsiveDropdown2 = _interopRequireDefault(_reactResponsiveDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popover = function (_Component) {
  (0, _inherits3.default)(Popover, _Component);

  function Popover() {
    (0, _classCallCheck3.default)(this, Popover);
    return (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).apply(this, arguments));
  }

  (0, _createClass3.default)(Popover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          clickOverlay = _props.clickOverlay,
          dropdownView = _props.dropdownView,
          overlayOptions = _props.overlayOptions,
          visible = _props.visible,
          width = _props.width;

      return _react2.default.createElement(
        _reactResponsiveDropdown2.default,
        (0, _extends3.default)({
          arrowSize: 10,
          borderColor: '#ccc',
          borderRadius: 0,
          borderWidth: 2,
          clickOverlay: clickOverlay,
          dropdownView: _react2.default.createElement(
            'div',
            { className: 'Popover' },
            dropdownView
          ),
          visible: visible,
          width: width
        }, overlayOptions),
        children
      );
    }
  }]);
  return Popover;
}(_react.Component);

Popover.propTypes = {
  /**
   * Child DOM elements comprising the content of the popover.
   */
  children: _propTypes2.default.any,
  /**
   * Function to be called when clicking outside the popover.
   */
  clickOverlay: _propTypes2.default.func,
  /**
   * The content of the popover.
   */
  dropdownView: _propTypes2.default.element,
  /**
   * Overlay options.
   */
  overlayOptions: _propTypes2.default.object,
  /**
   * Whether the popover is visible.
   */
  visible: _propTypes2.default.bool,
  /**
   * Width of the popover.
   */
  width: _propTypes2.default.number
};
Popover.defaultProps = {
  overlayOptions: {},
  visible: false,
  width: 300
};
exports.default = Popover;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Popover.js
// module id = 282
// module chunks = 0